import { route, number , string} from 'react-router-typesafe-routes/dom'
import { dateString } from '@/modules/shared/routes/codecs'

/**
 * Typed counterparts of `vehiclesRoutesMap`. See other modules' `routes-typed.ts`
 * for the shared pattern. Library quirk: path templates must not start or end
 * with `/`. `.path` returns the absolute form for `<Route path={...}/>`.
 */

const vehicleModuleBase = 'et/company/:companyId/vehicleModule' as const

export const VEHICLE_ROUTES = {
  list: route(`${vehicleModuleBase}/list`, {
    params: { companyId: string().defined() },
  }),
  basicData: route(`${vehicleModuleBase}/list/vehicle/:vehicleId`, {
    params: {
      companyId: string().defined(),
      vehicleId: number().defined(),
    },
  }),
  dailyActivity: route(
    `${vehicleModuleBase}/vehicle/:vehicleId/vehicleDailyActivity/date/:date`,
    {
      params: {
        companyId: string().defined(),
        vehicleId: number().defined(),
        date: dateString.defined(),
      },
    },
  ),
  weeklyActivity: route(
    `${vehicleModuleBase}/vehicle/:vehicleId/vehicleWeeklyActivity/date/:date`,
    {
      params: {
        companyId: string().defined(),
        vehicleId: number().defined(),
        date: dateString.defined(),
      },
    },
  ),
  calendar: route(
    `${vehicleModuleBase}/vehicle/:vehicleId/vehicleCalendar/year/:year`,
    {
      params: {
        companyId: string().defined(),
        vehicleId: number().defined(),
        year: number().defined(),
      },
    },
  ),
  blocksList: route(`${vehicleModuleBase}/blocks`, {
    params: { companyId: string().defined() },
  }),
  blocksDetail: route(`${vehicleModuleBase}/blocks/vehicle/:vehicleId`, {
    params: {
      companyId: string().defined(),
      vehicleId: number().defined(),
    },
  }),
}
